import { FC } from 'react';
import { Button, Modal, Stack } from "react-bootstrap"

interface IGenericModal {
    show?: boolean;
    handleClose?: any;
    handleAction?: any;
    genericModalHeaderTitle?: any;
    genericModalBodyContent?: string;
    buttonName?: string;
    genericModalSize?:any;
}

/**
 * Confirm Generic Modal Reusable Component
 *
 * @param {{ show: any; handleClose: any; handleAction: any; genericModalBodyContent: any; genericModalHeaderTitle: any; buttonName: any; genericModalSize?: string; }} param0 
 * @param {*} param0.show 
 * @param {*} param0.handleClose 
 * @param {*} param0.handleAction 
 * @param {*} param0.genericModalBodyContent 
 * @param {*} param0.genericModalHeaderTitle 
 * @param {*} param0.buttonName 
 * @param {string} [param0.genericModalSize='sm'] 
 * @returns {*} 
 */

const GenericModal: FC<IGenericModal> = ({
    show,
    handleClose,
    handleAction,
    genericModalBodyContent,
    genericModalHeaderTitle,
    buttonName,
    genericModalSize = 'sm'
}) => {
    return (
        <Modal
            show={show}
            onHide={handleClose}
            backdrop="static"
            keyboard={false}
            centered={true}
            scrollable={true}
            size={genericModalSize}
            className="theme-modal"
            enforceFocus={false}
        >
            <Modal.Header closeButton>
                <Modal.Title as="h5" className="fw-semibold">{genericModalHeaderTitle || ''}</Modal.Title>
            </Modal.Header>

            <Modal.Body className="custom-min-height-100 text-break">
                {genericModalBodyContent}
            </Modal.Body>

            <Modal.Footer className="py-2">
                <Stack direction="horizontal" gap={3} className="flex-wrap py-1">
                    <Button type='button' variant="outline-dark" onClick={handleClose} className="custom-min-width-85">
                        Cancel
                    </Button>
                    <Button type='submit' variant="primary" className="custom-min-width-85" onClick={handleAction} >
                        {buttonName ?? 'Submit'}
                    </Button>
                </Stack>
            </Modal.Footer>
        </Modal>
    );
}

export default GenericModal